<template>
  <div class="card">
    <div class="card-body">
      <h4 class="title text-primary mb-0">
        {{ __("Top active Ambassadors") }}
      </h4>
      <div class="mt-4">
        <Spinner v-if="loading" spinner-type="grow" min-height="320px" />
        <template v-else-if="ambassadors.length">
          <div
            v-for="(ambassador, i) in ambassadors"
            class="d-flex align-items-center gap-2 mb-3"
            :key="i"
          >
            <a :href="`/profile/${ambassador.user_name}`" target="_blank">
              <img
                :src="asset_file_url(ambassador.profile_picture)"
                @error="image_load_error"
                class="rounded-circle"
                height="40"
                alt="photo"
              />
            </a>
            <div>
              <a
                :href="`/profile/${ambassador.user_name}`"
                class="d-block text-primary"
                target="_blank"
              >
                {{
                  locale_attr(ambassador, "name_{lang}") || ambassador.name_en
                }}
              </a>
              <small>{{ ambassador.email }}</small>
            </div>
          </div>
        </template>
        <div
          v-else
          class="d-flex justify-content-center align-items-center"
          style="min-height: 320px"
        >
          {{ __("No data found") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Spinner from "../../components/Spinner";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      ambassadors: [],
      loading: false,
    };
  },

  mounted() {
    this.observe_visibility(this.$el, () => this.fetchAmbassadors());
  },

  methods: {
    fetchAmbassadors() {
      this.loading = true;
      axios
        .get("/dashboard/top-active-ambassadors")
        .then(({ data }) => (this.ambassadors = data.ambassadors))
        .catch(console.error)
        .finally(() => (this.loading = false));
    },
  },
};
</script>
